import { FC, Fragment } from 'react';

import { Clover } from 'lucide-react';
import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { AddLotteryForm } from './addLotteryForm/AddLotteryForm';
import { LotteryCard } from './lotteryCard/LotteryCard';
import { UISettingsButton } from './uiSettingsButton/UISettingsButton';

import css from './LotteriesPage.module.css';

import { lotteriesService } from 'v2/api/lotteriesService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';

export const LotteriesPage: FC = () => {
  const { data, isLoading, mutate } = useSWR('getLotteries', lotteriesService.getLotteries);

  return (
    <PageLayout className={css.lotteriesPage} overflow="hidden">
      <PageTitle action={<UISettingsButton />}>Lottery Settings</PageTitle>

      <div className={css.lotteriesPageContent}>
        <AddLotteryForm onSuccess={mutate} />

        <Card className={css.lotteriesListCard}>
          <CardHeader title="All Lotteries" icon={Clover} />

          {isLoading ? (
            <Loader />
          ) : (
            isNonNullish(data) && (
              <Fragment>
                {isEmpty(data) ? (
                  <EmptyPlaceholder />
                ) : (
                  <div className={css.lotteriesList}>
                    {data.map((lottery, i) => (
                      <LotteryCard key={lottery.id} lottery={lottery} number={i + 1} onRevalidate={mutate} />
                    ))}
                  </div>
                )}
              </Fragment>
            )
          )}
        </Card>
      </div>
    </PageLayout>
  );
};
